import { createStore, update } from '@kundinos/nanostores';
import { useStore } from '@kundinos/nanostores/react';

const inputFocusStore = createStore<boolean>();

const setIsFocused = (isFocused: boolean): void => {
  update(inputFocusStore, () => {
    const isInputFocused = isFocused;
    return isInputFocused;
  });
};

export const useInputFocuse = () => {
  return {
    inputIsFocused: useStore(inputFocusStore),
  };
};

export default { setIsFocused };
